var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{staticClass:"table-css",staticStyle:{"width":"100.1%"},attrs:{"no-data-text":_vm.$t('common.noData'),"columns":_vm.columns,"data":_vm.tableSecurityData,"height":"470","loading":_vm.securityLoadings}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21f6bd84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/monitor/logs/security/TableSecurity.vue
// module id = FTer
// module chunks = 0